var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145 85C145 118.136 118.136 145 85 145C51.8637 145 25 118.136 25 85C25 51.8637 51.8637 25 85 25C118.136 25 145 51.8637 145 85Z",
    fill: "#8BF2CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109 108V67.5556C109 66.451 108.105 65.5556 107 65.5556H103.444V61C103.444 60.4477 102.997 60 102.444 60H96.1111C95.5588 60 95.1111 60.4477 95.1111 61V65.5556H72.8889V61C72.8889 60.4477 72.4412 60 71.8889 60H65.5556C65.0033 60 64.5556 60.4477 64.5556 61V65.5556H61C59.8954 65.5556 59 66.451 59 67.5556V108C59 109.105 59.8954 110 61 110H107C108.105 110 109 109.105 109 108ZM106.222 82.2222H61.7778V105.222C61.7778 106.327 62.6732 107.222 63.7778 107.222H104.222C105.327 107.222 106.222 106.327 106.222 105.222V82.2222Z",
    fill: "#4B27E0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.5566,
    y: 85,
    width: 10.0823,
    height: 8.33333,
    rx: 1,
    fill: "#4B27E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5566,
    y: 96.1113,
    width: 10.0823,
    height: 8.33333,
    rx: 1,
    fill: "#4B27E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.9609,
    y: 96.1113,
    width: 10.0823,
    height: 8.33333,
    rx: 1,
    fill: "#4B27E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93.3652,
    y: 96.1113,
    width: 10.0823,
    height: 8.33333,
    rx: 1,
    fill: "#4B27E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78.9609,
    y: 85,
    width: 10.0823,
    height: 8.33333,
    rx: 1,
    fill: "#4B27E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 93.3652,
    y: 85,
    width: 10.0823,
    height: 8.33333,
    rx: 1,
    fill: "#4B27E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9d4b6b5d.svg";
export { ForwardRef as ReactComponent };